import { FC, useEffect, VFC } from 'react';
import { useSelector } from 'react-redux';
import { useAuth } from 'react-oidc-context';

import { useConfig } from '../../config';
import { fromAuth, useAppDispatch } from '../../store';
import { useSignOut } from '../../auth/hooks/useSignOut';
import { useLaunchDarkly } from '../../launchdarkly';

const LogoutPage: VFC = () => {
  const { config } = useConfig();
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector(fromAuth.selectIsAuthenticated);

  useEffect(() => {
    dispatch(fromAuth.doLogout());
  }, [dispatch]);

  if (config && !isAuthenticated) {
    // if is onpremises, redirect to TestOps. Otherwise, redirect to website
    // try to use configurable host. If it's invalid, use current host
    if (config.onpremise) {
      try {
        // Rediect to TestOps logout to remove TO token in cookies
        const uri = new URL(`${process.env.REACT_APP_ADMIN_URL}/logout`);
        window.location.replace(uri.toString());
      } catch (e) {
        window.location.replace(`${window.location.origin}/logout`);
      }
    } else {
      window.location.replace(`${window.location.origin}/login`);
    }
  }

  return null;
};

const LogoutPageV2: FC = () => {
  const auth = useAuth();
  const { signOutWithPath } = useSignOut();

  useEffect(() => {
    if (!auth || auth.isLoading) return;
    if (typeof signOutWithPath === 'function') {
      signOutWithPath();
    } else {
      window.location.href = '/login';
    }
  }, [auth, signOutWithPath]);

  return null;
};

const Logout: FC = () => {
  const { initialized, flags } = useLaunchDarkly();

  if (!initialized) {
    // If LaunchDarkly is not initialized, we should not render the logout page
    return <></>;
  }

  if (flags?.loginV2Enabled) {
    return <LogoutPageV2 />;
  }

  return <LogoutPage />;
};

export default Logout;
